<template>
  <div class="navbar__cart" :class="sidecartOpen ? 'open' : ''">
    <cart-modal>
      <v-button
        label="Open Cart"
        @click="gotoCart()"
        aria-label="Open Cart"
      >
        <icon :name="homePagemenuColors" size="22px" class="navbar__cart-icon--desktop"></icon>
        <icon :name="homePagemenuColors" size="22px" class="navbar__cart-icon--mobile"></icon>
        <span
          class="cart-bubble-quantity navbar__cart__quantity"
          v-if="numCartItems > 0"
          :style="bubbleColorsBackground"
        >
          <span
            class="cart-bubble-count navbar__cart__count"
            :style="bubbleColorsText"
            :class="[
              { 'cart-bubble-count--small': numCartItems >= 100 }
            ]"
            >{{ displayItemCount }}</span
          >
        </span>
      </v-button>
    </cart-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import VButton from '@/scripts/components/buttons/VButton.vue'
import Icon from '@/scripts/components/basic/Icon.vue'
import CartModal from '@/scripts/components/cart/CartModal.vue'

export default {
  name: 'NavbarCart',
  components: { VButton, Icon, CartModal },
  props: {
    cartBubbleColors: Object,
    theme: String,
    cartIcon:{
      type: Object,
      default:{light:'cart-white','dark':'cart'}
    },
    h1:{
      type:Boolean,
      default: false
    }
  },
  computed: {
    //bubble background color and text color return from the cart object
    bubbleColorsBackground() {
      return {
        backgroundColor: this.cartBubbleColors.bubbleBg
      };
    },
    bubbleColorsText() {
      return {
        color: this.cartBubbleColors.bubbleText,
      };
    },
    ...mapState({
      checkout: state => state.cart.checkout,
      sidecartOpen: state => state.cart.sidecartOpen
    }),
    homePagemenuColors(){
      //true means transparent
      //false means white background
      return this.h1 ? this.cartIcon.lightIcon : (this.cartIcon.darkIcon.trim()==""?'cart':this.cartIcon.darkIcon);
    },
    numCartItems () {
      return this.checkout.item_count || 0
    },
    displayItemCount () {
      return this.numCartItems < 100 ? this.numCartItems : '99+'
    }
  },

  methods: {
    gotoCart () {
       window.location.href="/cart"
    }
  }
}
</script>

<style scoped lang="scss">
.navbar__cart {
  position: relative;
  margin-right: 10px;
  opacity: 1;
  transition: opacity 100ms ease;

  @include desktop-up {
    margin-right: 0;
  }
}

.navbar__cart-icon--desktop {
  max-width: 20px;
  max-height: 22px;
  display: none;
  @include tablet-up {
    display: block;
  }
}
.navbar__cart-icon--mobile {
  max-width: 20px;
  max-height: 22px;
  display: block;
  @include tablet-up {
    display: none;
  }
}

.navbar__cart .button--icon {
  border: 0;
  min-width: 24px;
  height: 40px;
}
.open {
  opacity: 0;
}
</style>
